import { render, staticRenderFns } from "./chatgpt_train.vue?vue&type=template&id=339db1f3&scoped=true"
import script from "./chatgpt_train.vue?vue&type=script&lang=js"
export * from "./chatgpt_train.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339db1f3",
  null
  
)

export default component.exports